import classNames from 'classnames';
import React, { FC, useEffect, useRef, useState, ReactNode } from 'react';
import './svg-border.less';

interface SvgBorderProps {
  rx?: number; //圆角弧度
  strokeWidth?: number; //边框线宽度
  strokeDasharray?: string; //线长和线距
  className?: string;
  children: JSX.Element;
  noBorder?: boolean;
  color?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}
export const SvgBorder: FC<SvgBorderProps> = ({
  rx = 0,
  strokeWidth = 2,
  strokeDasharray = '13,4',
  className = '',
  noBorder = false,
  color = '#1b8bfe',
  style = {},
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const dom = wrapperRef.current;
    if (dom && dom?.children?.length === 2) {
      const targetDom = dom.lastElementChild as HTMLElement;
      if (targetDom !== null) {
        targetDom.style.position = 'absolute';
        targetDom.style.top = `${strokeWidth + 1}px`;
        targetDom.style.left = `${strokeWidth + 1}px`;
        targetDom.style.zIndex = '3';
        targetDom.style.borderRadius = rx + 'px';
        const width = targetDom.offsetWidth,
          height = targetDom.offsetHeight;
        setSize({
          width: width + 2, //防止压线，大一像素预留空间
          height: height + 2,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function cloneNode(children: JSX.Element): ReactNode {
    return React.Children.map(children, (element, idx) => {
      if (element.type.toString() === 'Symbol(react.fragment)') {
        if (element.props.children) {
          return cloneNode(element.props.children);
        } else {
          return null;
        }
      } else {
        return idx === 0 ? React.cloneElement(element) : null;
      }
    });
  }
  return (
    <div
      ref={wrapperRef}
      style={{
        width: "432px",
        height: "202px",
        ...style,
      }}
      className={classNames('custom-svg-border-wrapper', className)}
    >
      <svg
        className="svg-elem"
        xmlns="http://www.w3.org/2000/svg"
        width="434"
        height="204"
      >
        <rect
          fill="#fff"
          stroke={noBorder ? 'tansparent' : color}
          strokeWidth={strokeWidth}
          x={strokeWidth}
          y={strokeWidth}
          strokeDasharray={strokeDasharray}
          width={430}
          height={200}
          rx={rx}
        ></rect>
      </svg>
      {cloneNode(children)}
    </div>
  );
};
